import { ACCOUNT } from "./Pathes.ts";
import { get } from "./api.ts";
import { z } from "zod";
import { readDuneRaider } from "../cookies/CookieReader.ts";

export async function getAccount() {
  try {
    await get(ACCOUNT, z.void());
  } catch (e) {}
  return readDuneRaider();
}
